import { ReactNode, useEffect, useState } from 'react'
import classNames from 'classnames'
import Cookies from 'js-cookie'
import { isFunction } from 'lodash'

import Header from '../components/Header'
import Footer from '../components/Footer'
import { i18n } from '../i18n'
import { getLanguage } from '../utils/language'
import { User } from '../types/models'

// 2021년 1월 1일 이후 제거 예정
import IENotification from '../components/IENotification'

const IE_COOKIE = 'ie_noti_off'

interface Props {
  className?: string
  user?: User
  fullWidth?: boolean
  onInitialize?: () => void
  children: ReactNode
}

const isBrowserIE11 = () => {
  /* Trident for ie11 */
  var IEUa = navigator.userAgent.indexOf('Trident/7.0') > -1
  return IEUa
}

export default function BasicLayout({ className, user, fullWidth, onInitialize, children }: Props) {
  const [isInitialized, setIsInitialized] = useState(false)
  const [isIENotiOpen, setIsIENotiOpen] = useState(false)

  const initializeLanguage = async () => {
    const currentLanguage = getLanguage(user)
    await i18n.changeLanguage(currentLanguage)

    setIsInitialized(true)
  }

  useEffect(() => {
    if (isBrowserIE11()) {
      !Cookies.get(IE_COOKIE) && setIsIENotiOpen(true)
    }
  }, [])

  useEffect(() => {
    const init = async () => {
      await initializeLanguage()
      if (isFunction(onInitialize)) {
        onInitialize()
      }
    }
    init()
  }, [])

  const handleNotificationClose = () => {
    Cookies.set(IE_COOKIE, 'true', { expires: 1 })
    setIsIENotiOpen(false)
  }
  return (
    <div
      className={classNames(
        'BasicLayout',
        {
          'BasicLayout--initialized': isInitialized,
        },
        className
      )}
    >
      {isIENotiOpen && <IENotification onClose={handleNotificationClose} />}
      <Header />
      <div
        className={classNames('BasicLayout__main', {
          'BasicLayout__main--fullWidth': fullWidth,
        })}
        role="main"
      >
        {children}
      </div>
      <Footer />
    </div>
  )
}
